import React from 'react';
import { ATTRIBUTE_OPTIONS, VIEW_MODES } from './utils';
import { useSessionContext } from './SessionContext';
import AboutText from './AboutText';
import Legend from './Legend';

/* The H3-to-ADM switch.
 *
 * Both views read the same contract -- one row per area, one value per date -- so this
 * changes which pair of files is fetched and which deck.gl layer draws them, and nothing
 * else. Hexagons remain fully functional; the administrative view is additive.
 */
function ViewModePicker() {
  const { viewMode, setViewMode, isLoading } = useSessionContext();
  return (
    <div className="view-mode-picker">
      <span style={{ fontSize: '16px', fontWeight: 'bold', margin: '4px' }}>Map Areas</span>
      <div className="view-mode-options">
        {Object.values(VIEW_MODES).map((mode) => (
          <button
            key={mode.key}
            type="button"
            disabled={isLoading}
            className={mode.key === viewMode ? 'view-mode-option selected' : 'view-mode-option'}
            onClick={() => setViewMode(mode.key)}
          >
            {mode.label}
          </button>
        ))}
      </div>
    </div>
  );
}

function AreaOpacityControl() {
  const { hexagonOpacity, setHexagonOpacity, viewMode } = useSessionContext();
  const label = viewMode === 'adm' ? 'Region Opacity' : 'Hexagon Opacity';
  return (
    <div className="hexagon-opacity-control">
      <span style={{ fontSize: '16px', fontWeight: 'bold', margin: '4px' }}>{label}</span>
      <input
        className="slider opacity-slider"
        style={{ margin: '10px 0' }}
        type="range"
        min={1}
        max={100}
        value={hexagonOpacity}
        onChange={(event) => setHexagonOpacity(parseInt(event.target.value, 10))}
      />
    </div>
  );
}

function AttributePicker() {
  const { selectedAttribute, setSelectedAttribute } = useSessionContext();
  return (
    <div className="attribute-dropdown">
      <select
        value={selectedAttribute}
        onChange={(e) => setSelectedAttribute(e.target.value)}
      >
        {Object.entries(ATTRIBUTE_OPTIONS).map(([value, config]) => (
          <option key={value} value={value}>{config.label}</option>
        ))}
      </select>
    </div>
  );
}

export default function RightPanel() {
  const { lightInterface } = useSessionContext();
  return (
    <div className="frosted right-panel">
      <div className="no-mobile">
        <Legend />
      </div>
      <ViewModePicker />
      <hr className="divider" />
      {!lightInterface && (
        <>
          <AttributePicker />
          <hr className="divider" />
        </>
      )}
      <AreaOpacityControl />
      {!lightInterface && (
        <>
          <hr className="divider about-text-divider" />
          <AboutText />
        </>
      )}
    </div>
  );
}
